import { useTranslation } from 'react-i18next';
import React, { useState, useRef, useMemo } from 'react';
import LiveAuctionNav from './LiveAuctionNav.js';
import * as queries from '../../queries';
import { useParams } from 'react-router-dom';
import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import AuctionSum from '../../utils/AuctionSum';
import { axiosInstance } from '../../utils/axiosInterceptor.js';
import Pagination from '../../utils/Pagination.js';
import SearchBarGraph from '../../utils/SearchBarGraph.js';
import ImageUtil from '../../utils/ImageUtil';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { icons } from '../../utils/iconsSrc.js'
import DataTable from '../../utils/DataTable';
import Select from 'react-select';
import { useGeneralInfo } from '../../utils/GeneralnfoContext.js';
import bidClient from '../../bidClient.js';
import client from '../../bidClient.js';
const AuctionLiveRegistration = () => {
    const { t } = useTranslation();
    const { devices } = useGeneralInfo();
    const { auctionID } = useParams();
    const MySwal = withReactContent(Swal);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [orderBy, setOrderBy] = useState(['-AllowStatus', '-TotalBidCount']);
    const [sortDirection, setSortDirection] = useState('asc');
    const [showFullPageDiv, setShowFullPageDiv] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiDjangoUrl = process.env.REACT_APP_BIDDJANGO_URL;
    const [upsertItemLimit] = useMutation(queries.UPDATE_ITEMLIMIT);
    const [approveCustomer] = useMutation(queries.APPOVECUSTOMER);
    const [updateTotalLimit] = useMutation(queries.UPDATE_BIDLIMIT_TOTAL);
    const [updateAllowAuction] = useMutation(queries.UPDATEALLOWAUCTION);
    const [bid1Item] = useMutation(queries.BID1ITEMADMIN);
    const [declineBid] = useMutation(queries.DECLINEBID);
    const [filters, setFilters] = useState({});
    const [search, setSearch] = useState('');
    const [ItemStatusIn, setItemStatusIn] = useState([0, 1, 2, 3]);
    const [upsertAccountLevel] = useMutation(queries.EDITACCOUNTLEVEL);
    const [selectedItemStatus, setSelectedItemStatus] = useState([
        {
            "value": 0,
            "label": "OutBid"
        },
        {
            "value": 2,
            "label": "Wining"
        },
        {
            "value": 1,
            "label": "Pending"
        },
        {
            "value": 3,
            "label": "Declined"
        }
    ]);
    const [selectedOptions, setSelectedOptions] = useState('');
    const editValues = useRef({});

    const tabs = [
        { label: 'Live Lots', value: `/admin/auctions/current/${auctionID}/livelots` },
        { label: 'Check In', value: `/admin/auctions/current/${auctionID}/liveRegistration` }
    ];

    const { loading, error, data } = useQuery(queries.GETBIDCHECKADMIN, {
        client: bidClient,
        variables: {
            AuctionID: auctionID,
            page,
            pageSize,
            orderBy,
            search,
        },
        fetchPolicy: 'network-only',
        pollInterval: 10000,
    });
    const totalPageNum = data?.allBidCheckAdmin?.totalPageNum || 1;
    const totalCount = data?.allBidCheckAdmin?.totalCount || 0;
    const customers = data?.allBidCheckAdmin?.data || [];

    const [getBidHistory, { data: dataBidHistory, refetch: refetchBidHistory }] = useLazyQuery(queries.GET_BIDHISTORY_BYCUSTOMERPERAUCTION, {
        client: bidClient
    });
    const [getItems] = useLazyQuery(queries.GETITEMBYITEMSTATUS);

    const openFullPageDiv = async (event, customer) => {
        event.preventDefault();
        setSelectedCustomer(customer);
        await getBidHistory({
            variables: {
                CustomerID: parseInt(customer.CustomerID),
                AuctionID: auctionID,
                CustomerID2: String(customer.CustomerID),
                AuctionID2: auctionID,
                ItemStatusIn: ItemStatusIn.length === 0 ? null : ItemStatusIn,
                pageSize: 1000,
            },
            "refech-policy": "network-only"
        });
        refetchBidHistory();
        setShowFullPageDiv(true);
    };

    const closeFullPageDiv = () => {
        setShowFullPageDiv(false);
        setSelectedCustomer(null);
    };

    const startEditing = (lot) => {
        Swal.fire({
            title: t('Edit Lot'),
            html: `
                <div class="edit-bid-detail-input-list" >
                <label for="swal-input1">${t("Item Status")}</label>
                <select id="swal-input1" class="swal2-input">
                    <option value="5" ${lot.ItemStatus === 5 ? 'selected' : ''}>${t("Approved")}</option>
                    <option value="3" ${lot.ItemStatus === 3 ? 'selected' : ''}>${t("Decline")}</option>
                </select>
                </div>
                <br />
                `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: t('Save'),
            preConfirm: () => {
                const itemStatus = document.getElementById('swal-input1').value;
                return { itemStatus };
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const { itemStatus } = result.value;
                editValues.current = {
                    LotID: lot.LotID,
                    ItemStatus: itemStatus,
                };
                saveEdits(lot.AllowAuctionID, lot.CustomerID, lot);
            }
        });
    };

    const saveEdits = async (AllowAuctionID, CustomerID, lot) => {
        const newItemStatus = parseInt(editValues.current.ItemStatus);
        const newBidLimit = parseFloat(editValues.current.BidLimit);
        const currentMaxBid = parseFloat(lot.CusMaxBid);
        const totalBidLimit = parseFloat(dataBidHistory?.oneAllowAuction?.TotalBidLimit);
        // console.log('newItemStatus:', newItemStatus);
        if (newItemStatus === 5 && newBidLimit < currentMaxBid) {
            alert(t('The new bid limit must be greater than the current max bid.'));
            return;
        }

        if (newItemStatus === 5) {
            await updateTotalLimitIfNeeded(AllowAuctionID, newBidLimit, totalBidLimit);
            await approveBidForItem(CustomerID, lot, newBidLimit, currentMaxBid);
        }
        if (newItemStatus === 3) {
            await handleDeclineBid(CustomerID, lot);
        }

        // setEditingLot(null);
    };

    const updateTotalLimitIfNeeded = async (AllowAuctionID, newBidLimit, totalBidLimit) => {
        if (newBidLimit > totalBidLimit) {
            try {
                await updateTotalLimit({
                    variables: {
                        ID: AllowAuctionID,
                        TotalBidLimit: newBidLimit + totalBidLimit,
                    }
                });
            } catch (error) {
                console.error("Error updating total bid limit:", error);
                Swal.fire({ title: t('Error'), text: t('Failed to update total bid limit1'), icon: 'error' });
            }
        }
    };

    const updateBidLimit = async (BidListID, newBidLimit) => {
        try {
            await upsertItemLimit({
                variables: {
                    BidLimit: newBidLimit,
                    BidListID: parseInt(BidListID),
                }
            });
            Swal.fire({ title: t('Success'), text: `${t("Bid limit for BidListID")} ${BidListID} ${t("has been updated to")} ${newBidLimit}`, icon: 'success' });
            refetchBidHistory();
        } catch (error) {
            console.error("Error updating bid limit:", error);
            Swal.fire({ title: t('Error'), text: t('Failed to update bid limit'), icon: 'error' });
        }
    };

    const approveBidForItem = async (CustomerID, lot, newBidLimit, currentMaxBid) => {
        try {
            const response = await bid1Item({
                variables: {
                    AuctionId: auctionID,
                    bidLimitUpdate: newBidLimit,
                    cid: parseInt(CustomerID),
                    newPrice: currentMaxBid,
                    OAId: parseInt(lot.OnAuctionPKID),
                    BidListId: parseInt(lot.BidListID)
                }
            });
            if (!response.data.ApproveBidding.success) {
                Swal.fire({ title: t('Error'), text: t('Failed to approve bid'), icon: 'error' });
            } else {
                Swal.fire({ title: t('Success'), text: t('Bid approved successfully'), icon: 'success' });
                refetchBidHistory();
            }
        } catch (error) {
            console.error("Error approving bid for item:", lot, error);
            Swal.fire({ title: t('Error'), text: t('Failed to approve bid'), icon: 'error' });
        }
    };
    const handleDeclineBid = async (CustomerID, lot) => {
        try {
            const response = await declineBid({
                variables: {
                    cid: parseInt(CustomerID),
                    OAId: parseInt(lot.OnAuctionPKID),
                    BidListId: parseInt(lot.BidListID)
                }
            });
            if (!response.data.DeclineBidding.success) {
                Swal.fire({ title: t('Error'), text: t('Failed to decline bid'), icon: 'error' });
                return;
            } else {
                Swal.fire({ title: t('Success'), text: t('Bid declined successfully'), icon: 'success' });
                refetchBidHistory();

            }
        } catch (error) {
            console.error("Error decline bid for item:", lot, error);
            Swal.fire({ title: t('Error'), text: t('Failed to decline bid'), icon: 'error' });
        }
    };

    const handleEdit = async (customer) => {
        const { value: formValues } = await MySwal.fire({
            title: t('Edit All Bid Details'),
            html:
                `<div class="edit-bid-detail-input-list" >` +
                `<label for="status">${t("Status")}</label>` +
                `<select id="status" class="swal2-input">` +
                `<option value="0" ${dataBidHistory?.oneAllowAuction?.Status === 0 ? 'selected' : ''}>${t("Declined")}</option>` +
                `<option value="2" ${dataBidHistory?.oneAllowAuction?.Status === 2 ? 'selected' : ''}>${t("Approved")}</option>` +
                `</select>` +
                `</div>`,
            focusConfirm: false,
            preConfirm: () => {
                return {
                    status: document.getElementById('status').value,
                };
            }
        });
        if (formValues) {
            try {
                await axiosInstance.post(`${apiDjangoUrl}/changeCustomerStatus/`, {
                    auction_id: auctionID,
                    cid: customer.CustomerID,
                    new_status: parseInt(formValues.status)
                }
                );
                await updateAllowAuction({
                    variables: {
                        ID: customer.ID,
                        Status: parseInt(formValues.status),
                    }
                });
                Swal.fire({
                    title: t('Success'),
                    text: t('Bid details updated successfully'),
                    icon: 'success'
                });
                refetchBidHistory();
            } catch (error) {
                console.error("Error updating bid details:", error);
                Swal.fire({
                    title: t('Error'),
                    text: t('Failed to update bid details'),
                    icon: 'error'
                });
            }
        }
    };

    const options = [
        { value: 0, label: t('OutBid') },
        { value: 1, label: t('Pending') },
        { value: 2, label: t('Wining') },
        { value: 3, label: t('Declined') },
        { value: 4, label: t('OnlyWatch') }
    ];

    const handleFilterChange = (selectedOption) => {
        let itemStatusIn = selectedOption.map(option => option.value);
        setItemStatusIn(itemStatusIn);
        setSelectedItemStatus(selectedOption);

        // Set itemStatusIn to null if it's an empty array
        if (itemStatusIn.length === 0) {
            itemStatusIn = null;
        }

        // Define the new filter parameters
        const filterParams = {
            CustomerID: selectedCustomer.CustomerID,
            AuctionID: auctionID,
            CustomerID2: String(selectedCustomer.CustomerID),
            AuctionID2: auctionID,
            ItemStatusIn: itemStatusIn,
            pageSize: 1000
        };

        setPage(1);
        refetchBidHistory(filterParams);
    };

    const handleEditAccountLevel = (customer) => {
        upsertAccountLevel({ variables: { CustomerID: customer.CustomerID, AccountLevel: 1 } })
            .then(() => {
                approveAllBids(customer.ID, customer.CustomerID)
            })
            .catch(() => {
                Swal.fire(t('Error'), t('Error updating Account Level'), 'error');
            });
    };

    const FullPageDiv = ({ customer }) => {
        if (!customer) return null;
        return (
            (<div className="full-page-div">
                <div className="full-page-content">
                    <button onClick={closeFullPageDiv} style={{ position: 'absolute', top: '10px', right: '10px' }}>{t('Close')}</button>

                    <div className='flex items-center gap-4'>
                        <p className='m-0 leading-none'>{'USER BID HISTORY  --- '}</p>
                        <a href={`/admin/CustomerDetail/${customer.CustomerID}?origin=${origin}`} target="_blank" rel="noopener noreferrer" className='leading-none'>
                            {customer.Name}
                        </a>
                        {/* <button className='edit-with-text-btn flex items-center gap-1' onClick={() => handleEdit(customer)}> <span>{icons.edit}</span>{t('Edit All Permission')}</button> */}
                        <button className='edit-with-text-btn flex items-center gap-1' onClick={() => handleEdit(customer)}> <span>{icons.edit}</span>{t('Edit All Permission')}</button>
                    </div>

                    <div className='bid-history-customer-summary-info'>
                        <div className='customer-identity'>
                        </div>
                        <div className='customer-summary-data-info'>
                            {/* <div className='history-user-each-data'>
                                <label>{t('ItemBidLimit')}</label>
                                <span>{dataBidHistory?.oneAllowAuction?.ItemBidLimit}</span>
                            </div> */}
                            <div className='history-user-each-data'>
                                <label>{t('Status')}</label>
                                <span>
                                    {t((() => {
                                        switch (dataBidHistory?.oneAllowAuction?.Status) {
                                            case 0: return 'Declined';
                                            case 1: return 'Pending';
                                            case 2: return 'Approved';
                                            default: return '';
                                        }
                                    })())}
                                </span>
                            </div>
                            {/* <div className='history-user-each-data'>
                                <label>{t('TotalBidLimit')}</label>
                                <span>{dataBidHistory?.oneAllowAuction?.TotalBidLimit}</span>
                            </div> */}
                        </div>

                        <div className='manage-customer-operation'>
                            {/* <button onClick={() => approveAllBids(customer.ID, customer.CustomerID)} style={{ marginLeft: '10px' }}>{t('✔ Approve All Pending Bids')}</button> */}
                            {/* <button onClick={() => declineAllBids(customer.CustomerID)} style={{ marginLeft: '10px' }}>{t('🗙 Decline All Bids')}</button> */}
                        </div>
                    </div>
                    <div className='inventory-tag-container'>
                        <Select
                            options={options}
                            onChange={handleFilterChange}
                            isMulti
                            placeholder={t("Select Status")}
                            value={selectedItemStatus}
                        />
                    </div>
                    <div className='cus-history-detail-table'>
                        <p className='table-name'>{t('User Bids')}</p>
                        <table>
                            <thead>
                                <tr>
                                    <th>{t('Lots')}</th>
                                    <th>{t('Status')}</th>
                                    <th>{t('Limit')}</th>
                                    <th>{t('HighBid')}</th>
                                    <th>{t('MaxBid')}</th>
                                    {/* <th></th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {dataBidHistory?.allBidCheck?.data.map((lot, index) => (
                                    <tr key={index} style={{ backgroundColor: 'white', color: lot.ItemStatus === 1 ? '#c09853' : 'black' }}>
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ maxHeight: '8vh', maxWidth: '5vw', minHeight: '8vh', minWidth: '5vw', overflow: 'hidden' }}>
                                                    <ImageUtil
                                                        picPath={lot.Path}
                                                        alt={lot.Lead}
                                                        className={'item-image'}
                                                    />
                                                </div>
                                                <div>
                                                    <a href={`https://lplauction.ca/product/${auctionID}/${lot.OriginalItem}/${lot.OnAuctionPKID}`} target="_blank" rel="noopener noreferrer">
                                                        {lot.LotID} {lot.LotIDString || ''} ({lot.OriginalItem}) - {lot.Lead}
                                                    </a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            {(() => {
                                                switch (lot.ItemStatus) {
                                                    case 0: return <div className='status-label OutBid'>{t('OutBid')}</div>;
                                                    case 1: return <div className='status-label Pending'>{t('Pending')}</div>;
                                                    case 2: return <div className='status-label Winning'>{t('Winning')}</div>;
                                                    case 3: return <div className='status-label Decline'>{t('Decline')}</div>;
                                                    case 4: return <div className='status-label OnlyWatch'>{t('OnlyWatch')}</div>;
                                                    case 5: return <div className='status-label Approved'>{t('Approved')}</div>;
                                                    default: return '';
                                                }
                                            })()}
                                        </td>
                                        <td>{lot.BidLimit} </td>
                                        <td>{lot.CusHighBid}</td>
                                        <td>{lot.CusMaxBid}</td>
                                        {/* <td>
                                            <button className='only-edit-btn' onClick={() => startEditing(lot)}>{icons.edit}</button>
                                        </td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>)
        );
    };

    const approveAllBids = async (AllowAuctionID, CustomerID) => {
        const itemLimit = prompt(t("Enter the limit per item:"));
        if (itemLimit === null || isNaN(itemLimit)) {
            Swal.fire({ title: t('Error'), text: t('Invalid input for item limit. Please enter a valid number.'), icon: 'error' });
            return;
        }

        const totalLimit = prompt(t("Enter the total limit:"));
        if (totalLimit === null || isNaN(totalLimit)) {
            Swal.fire({ title: t('Error'), text: t('Invalid input for total limit. Please enter a valid number.'), icon: 'error' });
            return;
        }

        if (window.confirm(t("Are you sure you want to approve all pending bids?"))) {
            try {
                // Approve the customer first
                const response = await approveCustomer({
                    variables: {
                        ID: AllowAuctionID,
                        ItemBidLimit: parseFloat(itemLimit),
                        TotalBidLimit: parseFloat(totalLimit),
                    }
                });

                // if (!response.data.ApproveCustomer.success) {
                //     Swal.fire({ title: 'Error', text: 'Failed to approve customer. Please try again.', icon: 'error' });
                //     return;
                // }

                // Fetch pending items
                const responsedataHistory = await getItems({
                    variables: {
                        CustomerID: parseInt(CustomerID),
                        AuctionID: auctionID,
                        ItemStatusIn: [1, 4],
                        page: 1,
                        pageSize: 9999
                    },
                    fetchPolicy: "network-only"
                });
                // console.log('responsedataHistory:', responsedataHistory?.data?.allBidCheck?.data);
                const pendingItems = responsedataHistory?.data?.allBidCheck?.data;
                let allItemsSuccessful = true;

                // Approve each bid
                for (const item of pendingItems) {
                    try {
                        const response = await bid1Item({
                            variables: {
                                AuctionId: auctionID,
                                bidLimitUpdate: parseFloat(itemLimit),
                                cid: parseInt(CustomerID),
                                newPrice: parseFloat(item.CusMaxBid),
                                OAId: parseInt(item.OnAuctionPKID),
                                BidListId: parseInt(item.BidListID)
                            }
                        });

                        if (!response.data.ApproveBidding.success) {
                            Swal.fire({ title: t('Error'), text: t('Failed to approve some bids. Please try again.'), icon: 'error' });
                            allItemsSuccessful = false;
                            break;
                        }
                    } catch (error) {
                        console.error("Error approving bid for item:", item, error);
                        Swal.fire({ title: t('Error'), text: t('Failed to approve some bids. Please try again.'), icon: 'error' });
                        allItemsSuccessful = false;
                        break;
                    }
                }

                if (allItemsSuccessful) {
                    Swal.fire({ title: t('Success'), text: t('All bids have been approved.'), icon: 'success' });
                    refetchBidHistory();
                }
            } catch (error) {
                console.error("Error approving customer:", error);
                Swal.fire({ title: t('Error'), text: t('Failed to approve customer2. Please try again.'), icon: 'error' });
            }
        }
    };

    const declineAllBids = async (CustomerID) => {
        if (window.confirm(t("Are you sure you want to decline all bids?"))) {
            let allItemsSuccessful = true;
            const responsedataHistory = await getItems({
                variables: {
                    CustomerID: parseInt(CustomerID),
                    AuctionID: auctionID,
                    ItemStatusIn: [0, 1, 2],
                    page: 1,
                    pageSize: 9999
                },
                fetchPolicy: "network-only"
            });
            const needDeclinedItems = responsedataHistory?.data?.allBidCheck?.data;
            for (const item of needDeclinedItems) {
                try {
                    const response = await declineBid({
                        variables: {
                            cid: parseInt(CustomerID),
                            OAId: parseInt(item.OnAuctionPKID),
                            BidListId: parseInt(item.BidListID)
                        }
                    });

                    if (!response.data.DeclineBidding.success) {
                        Swal.fire({ title: t('Error'), text: t('Failed to Decline some bids. Please try again.'), icon: 'error' });
                        allItemsSuccessful = false;
                        break;
                    }
                } catch (error) {
                    console.error("Error Decline bid for item:", item, error);
                    Swal.fire({ title: t('Error'), text: t('Failed to Decline some bids. Please try again.'), icon: 'error' });
                    allItemsSuccessful = false;
                    break;
                }
            }

            if (allItemsSuccessful) {
                Swal.fire({ title: t('Success'), text: t('All bids have been Declined.'), icon: 'success' });
                refetchBidHistory();
            }
        }
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };

    const handleHeaderClick = (field) => {
        let sortField = field;
        let newSortDirection = 'asc';
        if (orderBy.includes(field)) {
            // If already sorted by this field, toggle between asc and desc
            newSortDirection = orderBy.startsWith('-') ? 'asc' : 'desc';
            sortField = orderBy.startsWith('-') ? field : '-' + field;
        }
        setOrderBy(sortField);
        setSortDirection(newSortDirection);
    };

    const allHeaders = [
        { label: 'Name', field: 'Name' },
        { label: 'Bids', field: 'TotalBidCount' },
        { label: 'HighBid', field: 'TotalCusHighBid' },
        { label: 'MaxBid', field: 'TotalCusMaxBid' },
        { label: 'TotalCount', field: 'TotalBidCount' },
        { label: 'Permission', field: 'AllowStatus' },
        // { label: 'ItemBidLimit', field: 'ItemBidLimit' },
        // { label: 'TotalBidLimit', field: 'TotalBidLimit' }
    ];

    const headers = useMemo(() => {
        const count = devices < 1 ? 2 : devices < 4 ? 5 : allHeaders.length;
        return allHeaders.slice(0, count);
    }, [devices]);

    const expandHeaders = [
        { label: 'Permission', field: 'AllowStatus' },
        // { label: 'ItemBidLimit', field: 'ItemBidLimit' },
        // { label: 'TotalBidLimit', field: 'TotalBidLimit' }
    ]
    const expandHeaders_small = [
        { label: 'HighBid', field: 'TotalCusHighBid' },
        { label: 'MaxBid', field: 'TotalCusMaxBid' },
        { label: 'TotalCount', field: 'TotalBidCount' },
        { label: 'Permission', field: 'AllowStatus' },
        // { label: 'ItemBidLimit', field: 'ItemBidLimit' },
        // { label: 'TotalBidLimit', field: 'TotalBidLimit' }
    ]

    if (error) return <p>{t('Error:')}{error.message}</p>;

    const handleSearch = (filter, searchTerm) => {
        if (filter) {
            setFilters(filter);
        } else {
            setFilters({});
        }

        setSearch(searchTerm);
        setPage(1);
    };

    const handleReset = () => {
        setSearch('');
        setFilters({});
        setSelectedOptions('');
        setOrderBy(['-AllowStatus', '-TotalBidCount']);
    };

    const handleSearchByChange = (newSearchBy, oldSearchBy) => {
        setSelectedOptions(newSearchBy);
        if (newSearchBy === '') {
            setFilters((prevFilters) => {
                const { [`${oldSearchBy}Ilike`]: _, ...rest } = prevFilters;
                return rest;
            });
            return;
        }
        const newFilters = { ...filters, [`${newSearchBy}Ilike`]: search };
        delete newFilters[`${oldSearchBy}Ilike`];
        setFilters(newFilters)
    };

    const searchOptions = [
        { value: '', label: 'All' },
        { value: 'Name', label: 'Name' },
    ];


    const renderRow = (customer) => (
        <>
            <td className="customer-info">
                <div className="customer-details">
                    <a href={`/admin/CustomerDetail/${customer.CustomerID}`} target="_blank" rel="noopener noreferrer">
                        {customer.Name}
                    </a>
                </div>
            </td>
            <td>
                <a href="#" onClick={(event) => openFullPageDiv(event, customer)}>
                    <div className="customer-aggregates">
                        <div className="aggregate-info">
                            <span className="aggregate-label">
                                <span className="aggregate-count">{customer.TotalBidCount || 0}</span>
                                <span className="aggregate-max-bid">({customer.TotalCusMaxBid || 0})</span>
                            </span>
                        </div>
                        {customer.TotalItemStatusPending > 0 && (
                            <div className="AmountItemNeedToDo each-customer-style">
                                <span>{customer.TotalItemStatusPending || 0}</span>
                            </div>
                        )}
                    </div>
                </a>
            </td>
            {devices > 0 && (<><td>{customer.TotalCusHighBid}</td>
                <td>{customer.TotalCusMaxBid}</td>
                <td>{customer.TotalBidCount}</td>

            </>)}
            {devices > 3 && (<><td>{t((() => {
                switch (customer.AllowStatus) {
                    case 0: return 'Declined';
                    case 1: return 'Pending';
                    case 2: return 'Approved';
                    default: return '';
                }
            })())}</td>
                {/* <td>{customer.ItemBidLimit}</td>
                <td>{customer.TotalBidLimit}</td> */}
            </>)}
        </>
    );
    const handleOrderByChange = (e) => {
        const newOrderBy = e.target.value;
        setOrderBy(newOrderBy);
        setPage(1);
    };

    const sortOptions = [
        { value: 'Name', label: t('Name') },
        { value: '-TotalBidCount', label: t('Bid Count (high to low)') },
        { value: 'TotalBidCount', label: t('Bid Count (low to high)') },
        { value: 'TotalCusMaxBid', label: t('Bid CAD (high to low)') },
        { value: '-TotalCusMaxBid', label: t('Bid CAD (low to high)') },
    ];
    const ExpandedRow = (row, expandedHeaders) => (
        expandedHeaders.map((header, index) => (
            <div key={index} className="flex text-[0.9em] text-[#4b4b4b] ">
                <lable className="min-w-[8rem] font-medium text-[#72747c]">{header.label} : </lable>
                <span >{header.label === "Permission" ?
                    t((() => {
                        switch (row[header.field]) {
                            case 0: return 'Declined';
                            case 1: return 'Pending';
                            case 2: return 'Approved';
                            default: return '';
                        }
                    })())
                    : row[header.field]}</span>
            </div>
        ))
    );
    return (
        <div className='main-container'>
            <LiveAuctionNav tabsList={tabs} />
            <div className='inner-contain-margin'>
                <AuctionSum auctionID={auctionID} />
                <div className='table-shadow-part'>
                    <div className='mb-2 flex justify-between items-center'>
                        <SearchBarGraph
                            onSearch={handleSearch}
                            onReset={handleReset}
                            searchTerm={search}
                            searchOptions={searchOptions}
                            selectedOptions={selectedOptions}
                            onSearchByChange={handleSearchByChange}
                        />
                        <div className="one-filter">
                            <label className='one-filter-label'>{t('Sort')}</label>
                            <select
                                value={orderBy}
                                onChange={handleOrderByChange}
                                className="ml-2 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                {sortOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <DataTable
                        headers={headers.map(header => ({
                            ...header,
                            label: `${header.label} ${orderBy.includes(header.field) ? (sortDirection === 'asc' ? '▲' : '▼') : ''}`
                        }))}
                        data={customers}
                        onHeaderClick={handleHeaderClick}
                        renderRow={renderRow}
                        loading={loading}
                        containerClassName='item-container-without-marginB table-for-ipad'
                        expandable={devices <= 3 ? true : false}
                        expandMode="multiple"
                        expandedHeaders={devices <= 0 ? expandHeaders_small : expandHeaders}
                        renderExpandedRow={ExpandedRow}
                    />
                    <Pagination
                        page={page}
                        pageSize={pageSize}
                        totalPageNum={totalPageNum}
                        totalCount={totalCount}
                        onPageChange={handlePageChange}
                        onPageSizeChange={handlePageSizeChange}
                        containerClassName={'pagination-container-sticky'}
                    />
                </div>
            </div>
            {showFullPageDiv && <FullPageDiv customer={selectedCustomer} />}
        </div>
    );
};

export default AuctionLiveRegistration;